import { render } from "./Chart2.vue?vue&type=template&id=3b34f294&ts=true"
import script from "./Chart2.vue?vue&type=script&lang=ts"
export * from "./Chart2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\map-web-doson\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__